import { render, staticRenderFns } from "./auth-form-input-text.vue?vue&type=template&id=e5021a90&scoped=true"
import script from "./auth-form-input-text.vue?vue&type=script&lang=js"
export * from "./auth-form-input-text.vue?vue&type=script&lang=js"
import style0 from "./auth-form-input-text.vue?vue&type=style&index=0&id=e5021a90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5021a90",
  null
  
)

export default component.exports